import { jsx } from '@emotion/core';
import { breadcrumb as breadcrumbWrapperStyles, item as breadcrumbsItemStyles, activeItem as activeBreadcrumbsItemStyles } from './styled';

var Title = function Title(_a) {
  var children = _a.children;
  return jsx("div", {
    css: breadcrumbWrapperStyles
  }, jsx("span", {
    css: [breadcrumbsItemStyles, activeBreadcrumbsItemStyles]
  }, children));
};

export default Title;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/breadcrumbs/title.js
// module id = 1108
// module chunks = 0